import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import Check from '@material-ui/icons/Check';
import StepConnector from '@material-ui/core/StepConnector';

export const CustomStepperConnector = withStyles(theme => ({
  alternativeLabel: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  active: {
    '& $line': {
      borderColor: theme.palette.green,
    },
  },
  completed: {
    '& $line': {
      borderColor: theme.palette.green,
    },
  },
  line: {
    borderColor: theme.palette.green,
    borderTopWidth: 3,
    borderRadius: 1,
  },
  root: {
    backgroundColor: 'initial',
  },
}))(StepConnector);

const useCustomStepperStepIconStyles = makeStyles(theme => ({
  root: {
    color: theme.palette.white,
    display: 'flex',
    height: 22,
    alignItems: 'center',
  },
  active: {
    color: theme.palette.green,
  },
  circle: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: 'currentColor',
  },
  completed: {
    color: theme.palette.green,
    zIndex: 1,
    fontSize: 18,
  },
}));

export const CustomStepperStepIcon = props => {
  const classes = useCustomStepperStepIconStyles();
  const { active, completed } = props;

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
      })}
    >
      {completed ? (
        <Check className={classes.completed} />
      ) : (
        <div className={classes.circle} />
      )}
    </div>
  );
};

CustomStepperStepIcon.propTypes = {
  /**
   * Whether this step is active.
   */
  active: PropTypes.bool,
  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: PropTypes.bool,
};
